module.exports = __webpack_public_path__ + "static/media/aldi7.cec059fc.jpg";